import React, { useState } from 'react'
import { ThemeProvider } from '@mui/material/styles'
import styled from 'styled-components'
import { Header } from './components/header'
import { SubHeader } from './components/subheader'
import { TabPanel } from './components/tabPanel'
import { Objective } from './components/objective'
import { Result } from './components/result'
import { Plan } from './components/plan'
import { theme } from './theme'

const initialState = {
  age: '',
  independenceAge: '',
  investment: 'Conservador',
  monthlyIncome: '',
  savedMoney: '',
  monthlySave: '',
  retirement: 'INSS',
  monthlyRetirement: '',
  ageRetirement: '',
  desiredRetirement: ''
}
// const initialState = {
//   age: 32,
//   independenceAge: 65,
//   investment: "Conservador",
//   monthlyIncome: 6500,
//   savedMoney: 11000,
//   monthlySave: 2000,
//   retirement: "INSS",
//   INSSage: 75,
//   INSSmonthlyRetirement: 4000,
//   desiredRetirement: 10000
// }

function App() {
  const [stepState, setStepState] = useState({
    index: 0,
    enable: 0
  })
  const [data, setData] = useState(initialState)

  return (<ThemeProvider theme={theme}>
    <Header theme={theme}/>
    <SubHeader theme={theme} stepState={stepState} setStepState={setStepState}/>

    <Container>
      <TabPanel theme={theme} stepState={stepState} index={0}>
        <Objective stepState={stepState} setStepState={setStepState} data={data} setData={setData}/>
      </TabPanel>
      <TabPanel theme={theme} stepState={stepState} index={1}>
        <Plan stepState={stepState} setStepState={setStepState} data={data} setData={setData}/>
      </TabPanel>
      <TabPanel theme={theme} stepState={stepState} index={2}>
        <Result stepState={stepState} setStepState={setStepState} data={data} setData={setData}/>
      </TabPanel>
    </Container>
  </ThemeProvider>)
}

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 40px 20px;

  @media (max-width: 767px) {
    padding: 20px 16px;
  }
`

export default App
